import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './ProgressBar.scss';

class ProgressBar extends Component {
	constructor(props) {
		super(props);
		this.state = {
			indicatorClassName : '',
		};
	}

	componentDidUpdate(prevProps) {
		const { currentStep : prevStep } = prevProps;
		const { currentStep } = this.props;
		if (prevStep !== currentStep) { this.setIndicatorClassName(currentStep); }
	}

	setIndicatorClassName = (currentStep) => {
		this.setState({ indicatorClassName : this.getIndicatorClassName(currentStep) });
	}

	getIndicatorClassName = (step) => {
		let className = '';
		for (let i = 1; i < step; i++) className += `complete${i} `;
		return className.trim();
	}

	iconClassName = (step) => {
		const { currentStep } = this.props;
		let className = 'checkpoint-icon rkf rkf-shield-check';
		if (step === currentStep) className += ' current';
		else if (step < currentStep) {
			className += ' complete';
		}
		return className;
	}

	render() {
		const { indicatorClassName } = this.state;
		const { steps, isLoggedIn } = this.props;
		return (
			<div id="progress-bar" className={classNames('col-xs-10 col-xs-offset-1 col-md-8 col-md-offset-2', { 'logged-in' : isLoggedIn })}>
				<div id="progress-indicator" className={indicatorClassName} />
				{ steps.map((step, i) => (
					<div id={`progress-step${i + 1}`} key={`step-${step.replace(/\s/gi, '')}`}>
						<div className="checkpoint-text">{step}</div>
						<i className={this.iconClassName(i + 1)} />
					</div>
				)) }
			</div>
		);
	}
}

ProgressBar.propTypes = {
	currentStep : PropTypes.number,
	steps       : PropTypes.array,
	isLoggedIn  : PropTypes.bool,
};

ProgressBar.defaultProps = {
	currentStep : 1,
	steps       : [],
	isLoggedIn  : false,
};

export default ProgressBar;
